import { DateTime } from 'luxon';
import { OrderStatus } from '../../Order/OrderStatus';
import { Pagination, paginationToParams } from '../../Pagination';
import { Period } from '../../Period';

export interface SalesReportFilter {
  startAt?: Date;
  endAt?: Date;
  status?: OrderStatus;
  period?: Period;
  pagination: Pagination;
}

export const getDefaultSalesReportFilter = (): SalesReportFilter => ({
  pagination: {
    page: 0,
    pageSize: 10,
  },
});

export const salesReportFilterToQueryParams = (filter: SalesReportFilter) => ({
  'start-at': filter.startAt
    ? DateTime.fromJSDate(filter.startAt).toISO()
    : undefined,
  'end-at': filter.endAt
    ? DateTime.fromJSDate(filter.endAt).toISO()
    : undefined,
  status: filter.status,
  period: filter.period,
  ...paginationToParams(filter.pagination),
});
